import { LEVELS, TYPES } from '../Const';

export const balanceSheetMappingBanking = {
  totalAssets: 'bsa53',
  cashAndPreciousMetals: 'bsa2',
  balancesWithTheSBV: 'bsb97',
  placementsWithAndLoansToOtherCreditInstitutions: 'bsb98',

  tradingSecuritiesNet: 'bsb99',
  tradingSecurities: 'bsb100',
  lessProvisionForDiminutionInValueOfTradingSecurities: 'bsb101',

  derivativesAndOtherFinancialAssets: 'bsb102',
  loansAndAdvancesToCustomersNet: 'bsb103',
  loansAndAdvancesToCustomers: 'bsb104',
  lessProvisionForLossesOnLoansAndAdvancesToCustomers: 'bsb105',

  investmentSecurities: 'bsb106',
  availableForSalesSecurities: 'bsb107',
  heldToMaturitySecurities: 'bsb108',
  lessProvisionForDiminutionInValueOfInvestmentSecurities: 'bsb109',

  investmentInOtherEntitiesAndLongTermInvestments: 'bsa43',
  investmentInJointVentures: 'bsa44',
  investmentInAssociateCompanies: 'bsa45',
  otherLongTermInvestments: 'bsa46',
  provisionForLongTermInvestments: 'bsa47',

  fixedAssets: 'bsa29',
  tangibleFixedAssets: 'bsa30',
  financeLeasedAssets: 'bsa33',
  intangibleFixedAssets: 'bsa36',

  investmentProperties: 'bsa40',

  otherAssets: 'bsb110',

  liabilitiesAndShareholderEquity: 'bsa96',

  totalLiabilities: 'bsa54',
  dueToGovAndBorrowingsFromSBV: 'bsb111',
  depositsAndBorrowingsFromOtherCreditInstitutions: 'bsb112',
  depositsFromCustomers: 'bsb113',
  derivativesAndOtherFinancialLiabilities: 'bsb114',
  fundsReceivedFromGovInternationalAndOtherInstitutions: 'bsb115',
  convertibleBondsCDsAndOtherValuablePapersIssued: 'bsb116',
  otherLiabilities: 'bsb117',

  shareholderEquity: 'bsa78',
  capital: 'bsb118',
  charterCapital: 'bsa80',
  fundForBasicConstruction: 'bsb119',
  sharePremium: 'bsa81',
  treasuryShares: 'bsa83',
  preferredShares: 'bsb120',
  otherCapitals: 'bsa82',
  reserves: 'bsb121',
  differenceUponAssetsRevaluation: 'bsa84',
  foreignCurrencyDifferenceReserve: 'bsa85',
  retainedEarnings: 'bsa90',

  minorityInterest: 'bsa95',
};

export const balanceSheetBankingRows = [
  {
    id: 'chart',
    type: TYPES.CHART,
    level: LEVELS.PARENT,
  },
].concat(
  Object.keys(balanceSheetMappingBanking).map(key => {
    const defaultItem = {
      id: balanceSheetMappingBanking[key],
      i18nKey: key,
      level: LEVELS.PARENT,
    };
    if (
      [
        balanceSheetMappingBanking.totalAssets,
        balanceSheetMappingBanking.cashAndPreciousMetals,
        balanceSheetMappingBanking.balancesWithTheSBV,
        balanceSheetMappingBanking.placementsWithAndLoansToOtherCreditInstitutions,
        balanceSheetMappingBanking.derivativesAndOtherFinancialAssets,
        balanceSheetMappingBanking.investmentProperties,
        balanceSheetMappingBanking.otherAssets,
        balanceSheetMappingBanking.liabilitiesAndShareholderEquity,
        balanceSheetMappingBanking.minorityInterest,
      ].includes(balanceSheetMappingBanking[key])
    ) {
      return defaultItem;
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.tradingSecuritiesNet
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.tradingSecurities,
          balanceSheetMappingBanking.lessProvisionForDiminutionInValueOfTradingSecurities,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.loansAndAdvancesToCustomersNet
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.loansAndAdvancesToCustomers,
          balanceSheetMappingBanking.lessProvisionForLossesOnLoansAndAdvancesToCustomers,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.investmentSecurities
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.availableForSalesSecurities,
          balanceSheetMappingBanking.heldToMaturitySecurities,
          balanceSheetMappingBanking.lessProvisionForDiminutionInValueOfInvestmentSecurities,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.investmentInOtherEntitiesAndLongTermInvestments
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.investmentInJointVentures,
          balanceSheetMappingBanking.investmentInAssociateCompanies,
          balanceSheetMappingBanking.otherLongTermInvestments,
          balanceSheetMappingBanking.provisionForLongTermInvestments,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] === balanceSheetMappingBanking.fixedAssets
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.tangibleFixedAssets,
          balanceSheetMappingBanking.financeLeasedAssets,
          balanceSheetMappingBanking.intangibleFixedAssets,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.totalLiabilities
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.dueToGovAndBorrowingsFromSBV,
          balanceSheetMappingBanking.depositsAndBorrowingsFromOtherCreditInstitutions,
          balanceSheetMappingBanking.depositsFromCustomers,
          balanceSheetMappingBanking.derivativesAndOtherFinancialLiabilities,
          balanceSheetMappingBanking.fundsReceivedFromGovInternationalAndOtherInstitutions,
          balanceSheetMappingBanking.convertibleBondsCDsAndOtherValuablePapersIssued,
          balanceSheetMappingBanking.otherLiabilities,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] ===
      balanceSheetMappingBanking.shareholderEquity
    ) {
      return {
        ...defaultItem,
        children: [
          balanceSheetMappingBanking.capital,
          balanceSheetMappingBanking.reserves,
          balanceSheetMappingBanking.differenceUponAssetsRevaluation,
          balanceSheetMappingBanking.foreignCurrencyDifferenceReserve,
          balanceSheetMappingBanking.retainedEarnings,
        ],
      };
    }

    if (
      balanceSheetMappingBanking[key] === balanceSheetMappingBanking.capital
    ) {
      return {
        ...defaultItem,
        level: LEVELS.CHILD,
        children: [
          balanceSheetMappingBanking.charterCapital,
          balanceSheetMappingBanking.fundForBasicConstruction,
          balanceSheetMappingBanking.sharePremium,
          balanceSheetMappingBanking.treasuryShares,
          balanceSheetMappingBanking.preferredShares,
          balanceSheetMappingBanking.otherCapitals,
        ],
      };
    }

    if (
      [
        balanceSheetMappingBanking.charterCapital,
        balanceSheetMappingBanking.fundForBasicConstruction,
        balanceSheetMappingBanking.sharePremium,
        balanceSheetMappingBanking.treasuryShares,
        balanceSheetMappingBanking.preferredShares,
        balanceSheetMappingBanking.otherCapitals,
      ].includes(balanceSheetMappingBanking[key])
    ) {
      return {
        ...defaultItem,
        level: LEVELS.THREE,
      };
    }

    return {
      ...defaultItem,
      level: LEVELS.CHILD,
    };
  }),
);
